import React, {useState, useRef, useEffect} from 'react';
import {useMensajes} from '../../hooks/useMensajes';
import {Mensaje} from './Mensaje';
import {SendMensajes} from './SendMensajes';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';

export const ChatMensajes = () => {
	/* Using the `useSessionStore` hook to get the `Usuario` from the `UsuarioContext` */
	const [Usuario] = useSessionStore(UsuarioContext);

	/* Destructuring the `useMensajes` hook. */
	const {ListaMen, addMensaje, TextMensaje, onInputChange, handleKeypress} = useMensajes(Usuario);
	/* A scroll type object that is used to scroll to the bottom of the chat window. */
	const scrollType = {
		duration: 500,
		delay: 50,
		smooth: true, // linear “easeInQuint” “easeOutCubic”
		offset: -10,
	};

	/* Rendering the `Mensaje` component and the `SendMensajes` component. */
	return (
		<div className='chatMensajes'>
			<div
				className='mensajesChatMensajes'
				Id='mensajesChatMensajes'
			>
				{
					/* Rendering the `Mensaje` component. */
					ListaMen.map((element, key) => (
						<Mensaje
							mensaje={element.mensaje}
							horaMensaje={element.horaMensaje}
							tipo={element.tipo}
							key={key}
						/>
					))
				}
			</div>

			<SendMensajes
				TextMensaje={TextMensaje}
				addMensaje={addMensaje}
				onInputChange={onInputChange}
				handleKeypress={handleKeypress}
			/>
		</div>
	);
};
